
export const NAME_FREAK = 'SPINNAX_FREAK'
export const NAME_FREAK_DISPLAY = 'SPINNAX FREAK'

// export const URL_API = 'http://127.0.0.1:8001'
export const URL_API = 'https://api.spinnax.com'

export const BLE_SERVICE_SPINNAX = '0000fe40-cc7a-482a-984a-7f2ed5b3e58f'
export const BLE_CHARACTERISTIC_CMD = '0000fe41-8e22-4541-9d4c-21edae82ed19'
export const BLE_CHARACTERISTIC_RSP = '0000fe42-8e22-4541-9d4c-21edae82ed19'
export const BLE_MTU = 251

export const ID_DEVICE_DEFAULT = '00:00:00:00:00:00'

export const INFIX = '_'
export const SLASH = '/'

export const AREA_TEST = 'test'
export const API_V_1 = 'v_1'
export const USER_ANON = '__anon__'

export const NAME_RECORD = 'Record'
export const SUFFIX_RECORD = '.json'
export const PATH_DIRECTORY_RECORDS = NAME_RECORD + SLASH
export const PREFIX_RECORD = NAME_RECORD + INFIX
export const URL_API_RECORD = URL_API + SLASH + API_V_1 + SLASH + NAME_RECORD + SLASH

export const NAME_PLAY = 'Play'
export const SUFFIX_PLAY = '.json'
export const PATH_DIRECTORY_PLAY = NAME_PLAY + SLASH
export const PREFIX_PLAY = NAME_PLAY + INFIX
export const URL_API_PLAY = URL_API + SLASH + API_V_1 + SLASH + NAME_PLAY + SLASH

export const NAME_VIDEO = 'Video'  // Note: UPPERCASE!
export const SUFFIX_VIDEO = '.mp4'
export const URL_API_VIDEO = URL_API + SLASH + 'video' + SLASH  // Note: lowercase!

export const NAME_APP = 'android'
export const PATH_DIRECTORY_APP = NAME_APP + SLASH
export const PATH_APP = SLASH + PATH_DIRECTORY_APP
export const URL_API_APP = URL_API + PATH_APP

export const NAME_FIRMWARE = 'firmware'
export const PATH_DIRECTORY_FIRMWARE = NAME_FIRMWARE + SLASH
export const PATH_FIRMWARE = SLASH + PATH_DIRECTORY_FIRMWARE
export const URL_API_FIRMWARE = URL_API + PATH_FIRMWARE
